import script from "./DividenIncome.vue?vue&type=script&setup=true&lang=js"
export * from "./DividenIncome.vue?vue&type=script&setup=true&lang=js"

import "./DividenIncome.vue?vue&type=style&index=0&id=0cc524d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc524d8"]])

export default __exports__